/**
 * @note Keep up to date with ./ProductNames until that file is deprecated
 * https://git.hubteam.com/HubSpot/growth-trials-meta/issues/38
 */
export const HUBSPOT_FREE = 'hubspot-free';
export const SALES_HUB_FREE = 'sales-hub-free';
export const SALES_HUB_STARTER = 'sales-hub-starter';
export const SALES_HUB_PROFESSIONAL = 'sales-hub-professional';
export const SALES_HUB_PROFESSIONAL_ONBOARDING = 'sales-hub-professional-onboarding';
export const SALES_HUB_ENTERPRISE = 'sales-hub-enterprise';
export const SALES_HUB_ENTERPRISE_ONBOARDING = 'sales-hub-enterprise-onboarding';

// Only use this for legacy stuff
export const MARKETING_HUB_BASIC = 'marketing-hub-basic';
export const MARKETING_HUB_FREE = 'marketing-hub-free';
export const MARKETING_HUB_STARTER = 'marketing-hub-starter';
export const MARKETING_HUB_PROFESSIONAL = 'marketing-hub-professional';
export const MARKETING_HUB_PROFESSIONAL_ONBOARDING = 'marketing-hub-professional-onboarding';
export const MARKETING_HUB_ENTERPRISE = 'marketing-hub-enterprise';
export const MARKETING_HUB_ENTERPRISE_ONBOARDING = 'marketing-hub-enterprise-onboarding';
export const SERVICE_HUB_FREE = 'service-hub-free';
export const SERVICE_HUB_STARTER = 'service-hub-starter';
export const SERVICE_HUB_PROFESSIONAL = 'service-hub-professional';
export const SERVICE_HUB_PROFESSIONAL_ONBOARDING = 'service-hub-professional-onboarding';
export const SERVICE_HUB_ENTERPRISE = 'service-hub-enterprise';
export const SERVICE_HUB_ENTERPRISE_ONBOARDING = 'service-hub-enterprise-onboarding';
export const CMS_HUB_FREE = 'cms-hub-free';
export const CMS_HUB_STARTER = 'cms-hub-starter';
export const CMS_HUB_PROFESSIONAL = 'cms-hub-professional';
export const CMS_HUB_ENTERPRISE = 'cms-hub-enterprise';
export const OPERATIONS_HUB_FREE = 'operations-hub-free';
export const OPERATIONS_HUB_STARTER = 'operations-hub-starter';
export const OPERATIONS_HUB_PROFESSIONAL = 'operations-hub-professional';
export const OPERATIONS_HUB_ENTERPRISE = 'operations-hub-enterprise';
export const DEDICATED_IP = 'tech-service-dedicated-ip-for-email';
export const CUSTOM_SSL = 'web-hosting-custom-ssl-pack';
export const REPORTING_LIMIT_INCREASE = 'reporting-limit-increase';
export const TRANSACTIONAL_EMAIL = 'transactional-email';
export const BRAND_DOMAIN = 'brand-domain';
export const MARKETING_SMS_ADDON = 'marketing-sms';
export const MARKETING_SMS_SHORT_CODE = 'marketing-sms-short-code';
export const API_LIMIT_INCREASE = 'api-limit-increase';
export const ADS_LIMIT_INCREASE = 'ads-limit-increase';
export const TEAMS_LIMIT_INCREASE = 'teams-limit-increase';
export const TRANSCRIPTION_LIMIT_INCREASE = 'transcription-limit-increase';
export const LISTS_LIMIT_INCREASE = 'lists-limit-increase';
export const DOMAINS_LIMIT_INCREASE = 'domains-limit-increase';
export const SANDBOX_LIMIT_INCREASE = 'sandbox-limit-increase';
export const CALLING_LIMIT_INCREASE = 'calling-limit-increase';
export const PHONE_LIMIT_INCREASE = 'phone-limit-increase';
export const ESIGNATURE_LIMIT_INCREASE = 'esignature-limit-increase';
export const WHATSAPP_LIMIT_INCREASE = 'whatsapp-limit-increase';
export const VIDEO_LIMIT_INCREASE = 'video-limit-increase';
export const MARKETING_SMS_LIMIT_INCREASE = 'marketing-sms-limit-increase';
export const WORKFLOWS_LIMIT_INCREASE = 'workflows-limit-increase';
export const USERS_LIMIT_INCREASE = 'users-limit-increase';
export const CUSTOM_OBJECTS_LIMIT_INCREASE = 'custom-objects-limit-increase';
export const CALCULATED_PROPERTIES_LIMIT_INCREASE = 'calculated-properties-limit-increase';
export const CUSTOM_PROPERTIES_LIMIT_INCREASE = 'custom-properties-limit-increase';
export const CRM_OBJECT_LIMIT_INCREASE = 'crm-object-limit-increase';
export const CRM_CONTACT_RECORDS_LIMIT_INCREASE = 'non-marketing-contacts-limit-increase';
export const STRATEGIC_CONSULTING_MONTHLY = 'strategic-consulting-monthly';
export const STRATEGIC_CONSULTING_ONGOING = 'strategic-consulting-ongoing';
export const STRATEGIC_CONSULTING_4_HOUR = 'strategic-consulting-4-hour';
export const INBOUND_CONSULTING_ADVANCED = 'inbound-consulting-advanced';
export const INBOUND_CONSULTING_PREMIUM = 'inbound-consulting-premium';
export const TECHNICAL_CONSULTING_ONGOING = 'technical-consulting-ongoing';
export const TECHNICAL_CONSULTING_4_HOUR = 'technical-consulting-4-hour';
export const TECHNICAL_CONSULTING_ADVANCED = 'technical-consulting-advanced';
export const TECHNICAL_CONSULTING_PREMIUM = 'technical-consulting-premium';
export const PREMIUM_CONSULTING = 'premium-consulting';
export const ONBOARDING_FOUNDATIONS = 'onboarding-foundations';
export const HUBSPOT_ACADEMY_GUIDED_ONBOARDING = 'HubSpot-Academy-Guided-Onboarding';
export const TRAINING_AGENCY_MARKETING_HUB_FUNDAMENTALS = 'training-agency-marketing-hub-fundamentals';
export const MARKETING_HUB_STARTER_ONBOARDING = 'marketing-hub-starter-onboarding';
export const SALES_HUB_STARTER_ONBOARDING = 'sales-hub-starter-onboarding';
export const SERVICE_HUB_STARTER_ONBOARDING = 'service-hub-starter-onboarding';
export const CMS_HUB_PROFESSIONAL_ONBOARDING = 'cms-hub-professional-onboarding';
export const CMS_HUB_ENTERPRISE_ONBOARDING = 'cms-hub-enterprise-onboarding';
export const HUBSPOT_FOR_STARTUPS_SETUP = 'hubspot-for-startups-setup';
export const BRAZIL_ONBOARDING = 'brazil-onboarding';
export const FIRST_FULL_TIME_MIGRATION = 'first-time-full-migration';
export const STARTER_KIT = 'starter-kit';
export const CRM_SUITE_STARTER_BUNDLE = 'crm-suite-starter-bundle';
export const CRM_SUITE_PROFESSIONAL_BUNDLE = 'crm-suite-professional-bundle';
export const CRM_SUITE_ENTERPRISE_BUNDLE = 'crm-suite-enterprise-bundle';
export const CORE_SEATS_INCLUDED_STARTER = 'core-seats-included-starter';
export const CORE_SEATS_STARTER = 'core-seats-starter';
export const CORE_SEATS_PROFESSIONAL = 'core-seats-professional';
export const CORE_SEATS_ENTERPRISE = 'core-seats-enterprise';
export const MARKETING_PLUS_PROFESSIONAL_BUNDLE = 'marketing-plus-professional-bundle';
export const MARKETING_PLUS_ENTERPRISE_BUNDLE = 'marketing-plus-enterprise-bundle';
export const BREEZE_INTELLIGENCE_CREDITS_100 = 'breeze-intelligence-credits-100';
export const BREEZE_INTELLIGENCE_CREDITS_1000 = 'breeze-intelligence-credits-1000';
export const BREEZE_INTELLIGENCE_CREDITS_10000 = 'breeze-intelligence-credits-10000';
export const BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED = 'breeze-intelligence-credits-100-committed';
export const BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED = 'breeze-intelligence-credits-1000-committed';
export const BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED = 'breeze-intelligence-credits-10000-committed';
export const BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_100 = 'breeze-intelligence-overage-credits-for-100';
export const BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_1000 = 'breeze-intelligence-overage-credits-for-1000';
export const BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_10000 = 'breeze-intelligence-overage-credits-for-10000';
export const HUBSPOT_CREDITS_COMMITTED = 'hubspot-credits-committed';
export const HUBSPOT_CREDITS_COMMITTED_OVERAGE = 'hubspot-credits-committed-overage';
export const HUBSPOT_CREDITS_OVERAGE = 'hubspot-credits-overage';
export const COMMERCE_HUB_FREE = 'commerce-hub-free';
export const COMMERCE_HUB_PROFESSIONAL = 'commerce-hub-professional';
export const COMMERCE_HUB_ENTERPRISE = 'commerce-hub-enterprise';
export const ADVANCED_ONBOARDING = 'advanced-onboarding';
export const ADVANCED_ONBOARDING_MIGRATION_SERVICES = 'advanced-onboarding-migration-services';
export const AGENCY_PIPELINE_GENERATION_TRAINING_PLUS = 'agency-pipeline-generation-training-plus';
export const AGENCY_SALES_SKILLS_TRAINING_PLUS = 'agency-sales-skills-training-plus';
export const ASSET_MIGRATION_BASE = 'asset-migration-base';
export const ASSET_MIGRATION_PREMIUM = 'asset-migration-premium';
export const BASIC_DESIGNATED_ACCOUNT_SERVICES = 'basic-designated-account-services';
export const BLOG_MIGRATION = 'blog-migration';
export const BREEZE_INTELLIGENCE_BACKFILL_ENRICHMENT = 'breeze-intelligence-backfill-enrichment';
export const BREEZE_INTELLIGENCE_BULK_ENRICHMENT = 'breeze-intelligence-bulk-enrichment';
export const BUSINESS_UNIT_EXTENSION = 'business-unit-extension';
export const CREATING_EFFECTIVE_INBOUND_CONTENT_TRAINING = 'creating-effective-inbound-content-training';
export const CRM_DATA_MIGRATION = 'crm-data-migration';
export const CRM_SUITE_ONBOARDING_ENTERPRISE = 'crm-suite-onboarding-enterprise';
export const CRM_SUITE_ONBOARDING_PREMIER = 'crm-suite-onboarding-premier';
export const CRM_SUITE_ONBOARDING_PROFESSIONAL = 'crm-suite-onboarding-professional';
export const CRM_TRAINING = 'crm-training';
export const CUSTOM_CLASSROOM_TRAINING = 'custom-classroom-training';
export const CUSTOM_CONSULTING = 'custom-consulting';
export const DATA_MIGRATION_CONSULTING = 'data-migration-consulting';
export const DATA_WAREHOUSE = 'data-warehouse';
export const EMAIL_TEMPLATE_SETUP = 'email-template-setup';
export const ENTERPRISE_EDUCATION_PROGRAM = 'enterprise-education-program';
export const ENTERPRISE_SUITE_ONBOARDING = 'enterprise-suite-onboarding';
export const EXECUTIVE_SUMMIT_HOW_HUBSPOT_BUILT_ITS_SALES_AND_MARKETING_MACHINE = 'executive-summit-how-hubspot-built-its-sales-and-marketing-machine';
export const FIRST_TIME_BLOG_MIGRATION = 'first-time-blog-migration';
export const FRIENDS_AND_FAMILY = 'friends-and-family';
export const FULL_MIGRATION = 'full-migration';
export const GOLD_CRM_DATA_MIGRATION = 'gold-crm-data-migration';
export const GRANTED_CORE_SEATS = 'granted-core-seats';
export const HUBSPOT_CRM_DATA_MIGRATION = 'hubspot-crm-data-migration';
export const HUBSPOT_IMPLEMENTATION_CONSULTING = 'hubspot-implementation-consulting';
export const IMPLEMENTATION_FEE_20K = '20k-implementation-fee';
export const INBOUND_CONSULTING_FOR_PARTNERS = 'inbound-consulting-for-partners';
export const INBOUND_CONSULTING_NEW_USER_TRAINING = 'inbound-consulting-new-user-training';
export const INBOUND_SUCCESS_CONTENT_ADVANTAGE = 'inbound-success-content-advantage';
export const INBOUND_SUCCESS_NON_PROFIT_ADVANTAGE = 'inbound-success-non-profit-advantage';
export const INDUSTRY_BUSINESS_CONSULTING_ONGOING = 'industry-business-consulting-ongoing';
export const INDUSTRY_TECHNICAL_CONSULTING_ONGOING = 'industry-technical-consulting-ongoing';
export const INTEGRATION_SUPPORT = 'integration-support';
export const LARGE_SERVICES = 'large-services';
export const LEAD_MANAGEMENT_AND_AUTOMATION_TRAINING = 'lead-management-and-automation-training';
export const LEGACY_MARKETING = 'legacy-marketing';
export const LEGACY_SALES_HUB_PROFESSIONAL_LIMITS = 'legacy-sales-hub-professional-limits';
export const MARKETING_HUB_ADVANCED_ONBOARDING = 'marketing-hub-advanced-onboarding';
export const MARKETING_HUB_ATTRACT_LEADS_TRAINING = 'marketing-hub-attract-leads-training';
export const MARKETING_HUB_BASIC_ONBOARDING = 'marketing-hub-basic-onboarding';
export const MARKETING_HUB_ENTERPRISE_LEGACY_FEATURES = 'marketing-hub-enterprise-legacy-features';
export const MARKETING_HUB_ENTERPRISE_ONBOARDING_LATAM = 'marketing-hub-enterprise-onboarding-latam';
export const MARKETING_HUB_GENERATE_LEADS_TRAINING = 'marketing-hub-generate-leads-training';
export const MARKETING_HUB_HANDOFF_LEADS_TRAINING = 'marketing-hub-handoff-leads-training';
export const MARKETING_HUB_NURTURE_LEADS_TRAINING = 'marketing-hub-nurture-leads-training';
export const MARKETING_HUB_PROFESSIONAL_ONBOARDING_LATAM = 'marketing-hub-professional-onboarding-latam';
export const MIGRATE_THEME = 'migrate-theme';
export const MIGRATE_THEME_CONTENT_MIGRATION = 'migrate-theme-content-migration';
export const MIGRATION_CONSULTING_4_HOUR = 'migration-consulting-4-hour';
export const MULTIPLE_PREMIERE_ONBOARDING = 'multiple-premier-onboarding';
export const NETSUITE_UPDATE_TEST = 'netsuite-update-test';
export const ONBOARDING_EXTENSION_4_HOUR = 'onboarding-extension-4-hour';
export const ONE_TIME_CREDIT = 'one-time-credit';
export const ONE_TIME_INBOUND_CONSULTING_FOR_PARTNERS = 'one-time-inbound-consulting-for-partners';
export const ONE_TIME_TECHNICAL_CONSULTING_FOR_PARTNERS = 'one-time-technical-consulting-for-partners';
export const ONSITE_ONBOARDING = 'onsite-onboarding';
export const PARTNER_20K_IMPLEMENTATION_FEE = 'partner-20k-implementation-fee';
export const PARTNER_ONBOARDING = 'partner-onboarding';
export const PARTNER_ONBOARDING_FOUNDATIONS = 'partner-onboarding-foundations';
export const PARTNER_PIPELINE_GENERATION_BOOTCAMP_PRO_TRAINING = 'partner-pipeline-generation-bootcamp-pro-training';
export const PARTNER_PRIVATE_CUSTOMER_TRAINING_BASE = 'partner-private-customer-training-base';
export const PARTNER_PRIVATE_CUSTOMER_TRAINING_BASE_ONSITE = 'partner-private-customer-training-base-onsite';
export const PARTNER_PRIVATE_TRAINING_PREMIUM = 'partner-private-training-premium';
export const PARTNER_SALES_SKILLS_BOOTCAMP_PRO_TRAINING = 'partner-sales-skills-bootcamp-pro-training';
export const PARTNER_TECHNICAL_ACCELERATOR = 'partner-technical-accelerator';
export const PAST_DUE_AMOUNT = 'past-due-amount';
export const PREMIUM_SUPPORT = 'premium-support';
export const PREMIUM_SUPPORT_SKU = 'premium-support-sku';
// ignore unexpected private class name
// eslint-disable-next-line hubspot-dev/no-private-classes
export const PRIVATE_CUSTOMER_TRAINING_BASE = 'private-customer-training-base';
export const PRIVATE_CUSTOMER_TRAINING_BASE_ONSITE =
// eslint-disable-next-line hubspot-dev/no-private-classes
'private-customer-training-base-onsite';
// eslint-disable-next-line hubspot-dev/no-private-classes
export const PRIVATE_TRAINING_BASE = 'private-training-base';
// eslint-disable-next-line hubspot-dev/no-private-classes
export const PRIVATE_TRAINING_PREMIUM = 'private-training-premium';
export const PROFESSIONAL_SUITE_ONBOARDING = 'professional-suite-onboarding';
export const QUICK_START_CONSULTATION = 'quick-start-consultation';
export const REFUND = 'refund';
export const REMOTE_TEAM_TRAINING = 'remote-team-training';
export const REOPEN_PORTAL = 'reopen-portal';
export const REPORTING_ADD_ON_TRAINING = 'reporting-add-on-training';
export const SALES_AND_MARKETING_ALIGNMENT = 'sales-and-marketing-alignment';
export const SALES_HUB_ADVANCED_ONBOARDING = 'sales-hub-advanced-onboarding';
export const SALES_HUB_AUTOMATION_TRAINING = 'sales-hub-automation-training';
export const SALES_HUB_CONFIGURE_YOUR_DEAL_PIPELINE_TRAINING = 'sales-hub-configure-your-deal-pipeline-training';
export const SALES_HUB_PRODUCTIVITY_TOOLS_TRAINING = 'sales-hub-productivity-tools-training';
export const SALES_HUB_REPORTING_TRAINING = 'sales-hub-reporting-training';
export const SALES_SETUP = 'sales-setup';
export const SENSITIVE_DATA = 'sensitive-data';
export const SERVICE_AVISON_YOUNG_IMPLEMENTATION = 'service-avison-young-implementation';
export const SERVICE_BLOCK_4_HOUR = 'service-block-4-hour';
export const SERVICE_BLOCK_8_HOUR = 'service-block-8-hour';
export const SERVICE_HUB_FUNDAMENTALS = 'service-hub-fundamentals';
export const SERVICE_SMS = 'service-sms';
export const SILVER_CRM_DATA_MIGRATION = 'silver-crm-data-migration';
export const STRATEGIC_CONSULTING_1_DAY = 'strategic-consulting-1-day';
export const TECH_SERVICE_FIRST_TIME_TEMPLATE_SETUP = 'tech-service-first-time-template-setup';
export const TECH_SERVICE_TEMPLATE_SETUP = 'tech-service-template-setup';
export const TECHNICAL_CONSULTING_1_DAY = 'technical-consulting-1-day';
export const TECHNICAL_CONSULTING_OPERATIONS_HUB_DATASYNC = 'technical-consulting-operations-hub-datasync';
export const TECHNICAL_CONSULTING_OPERATIONS_HUB_PROGRAMMABLE_AUTOMATION = 'technical-consulting-operations-hub-programmable-automation';
export const TECHNICAL_CONSULTING_PARTNERS = 'technical-consulting-partners';
export const TRAINING_AGENCY_ACCOUNT_MANAGEMENT_ESSENTIALS = 'training-agency-account-management-essentials';
export const TRAINING_AGENCY_CRM_MANAGEMENT = 'training-agency-crm-management';
export const TRAINING_BUILDING_AN_INBOUND_CAMPAIGN_FUNDAMENTALS = 'training-building-an-inbound-campaign-fundamentals';
export const TRAINING_OPTIMIZING_YOUR_SALES_WITH_HUBSPOT_CRM_TRAINING_COURSE = 'training-optimizing-your-sales-with-hubspot-crm-training-course';
export const TRAINING_SALES_AND_MARKETING_ALIGNMENT = 'training-sales-and-marketing-alignment';
export const TRAINING_SALES_HUB_FUNDAMENTALS = 'training-sales-hub-fundamentals';
export const UNLIMITED_CONTACTS = 'unlimited-contacts';
export const WEB_HOSTING_SSL_PACK = 'web-hosting-ssl-pack';
export const ENTERPRISE_FLEX_PROGRAM = 'enterprise-flex-program';
export const FLEX_SEAT = 'flex-seat';
export const CORE_SEATS_ENTERPRISE_HSOC = 'hsoc-core-seats-enterprise';
export const CORE_SEATS_PROFESSIONAL_HSOC = 'hsoc-core-seats-professional';
export const CORE_SEATS_STARTER_HSOC = 'hsoc-core-seats-starter';
export const FRONT_OFFICE_SEATS_ENTERPRISE_HSOC = 'hsoc-front-office-seats-enterprise';
export const FRONT_OFFICE_SEATS_PROFESSIONAL_HSOC = 'hsoc-front-office-seats-professional';
export const SOLUTIONS_PARTNER_PROGRAM = 'solutions-partner-program';